import BookingPage from '../../book';
export { getStaticProps } from '../../book';

import { GetStaticPaths } from 'next';
import hotelData from '../../../src/utils/hotelData';

const addLocale = (hotels: string[], locale: string) =>
	hotels.map((hotel) => ({
		params: {
			hotel,
		},
		locale,
	}));

export const getHotelPaths = () => {
	const hotelSlugs = Object.values(hotelData).map((h) => h.slug);
	return [...addLocale(hotelSlugs, 'is'), ...addLocale(hotelSlugs, 'en')];
};

export const getStaticPaths: GetStaticPaths = async () => {
	return {
		paths: getHotelPaths(),
		fallback: true, // false or 'blocking'
	};
};

export default BookingPage;
